import React from 'react';
import FeatureFlags from '../../../../../util/featureFlags';
import ComparisonModule from '../../ComparisonModule/ComparisonModule';
import './PaperTypeModal.less';

import paperTypeModalImage from '../../../../../assets/images/invitations/paper_types_modal.jpg';
import paperTypeModalImage2x from '../../../../../assets/images/invitations/paper_types_modal@2x.jpg';
import paperTypeDoubleThick from '../../../../../assets/images/invitations/papertypes/pdp_paperDoubleThick.jpg';
import paperTypeTripleThick from '../../../../../assets/images/invitations/papertypes/pdp_paperTripleThick.jpg';
import paperTypeNatural from '../../../../../assets/images/invitations/papertypes/pdp_paperNatural.jpg';
import paperTypeLinen from '../../../../../assets/images/invitations/papertypes/pdp_paperLinen.jpg';
import paperTypePearlescent from '../../../../../assets/images/invitations/papertypes/pdp_paperPearlescent.jpg';
import paperTypeRecycled from '../../../../../assets/images/invitations/papertypes/pdp_paperRecycled.jpg';
import paperTypeEggshell from '../../../../../assets/images/invitations/papertypes/pdp_paperEggshell.jpg';
import paperTypeSmooth from '../../../../../assets/images/invitations/papertypes/pdp_paperSmooth.jpg';

function PaperTypeModal({ hideProofBanner = false, overrides }) {
  if (FeatureFlags.get('invitesComparisonModuleMvp')) {
    return <ComparisonModule hideProofBanner={hideProofBanner} overrides={overrides} />;
  }

  return (
    <div className="paper-type-modal">
      <div className="row">
        <div className="col-xs-12 visible-xs-block">
          <div className="modal-image">
            <img
              src={paperTypeModalImage}
              srcSet={`${paperTypeModalImage2x} 2x`}
              className="img img-responsive"
              alt="Smooth, Eggshell, Recycled, Pearlescent, Linen, Natural, Double Thick, Triple Thick paper"
            />
          </div>
        </div>
        <div className="col-xs-12">
          <div className="modal-body">
            <h3>Get To Know Our Paper Types</h3>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img src={paperTypeSmooth} className="img img-responsive" alt="Smooth Paper" />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Smooth</div>
                <div className="section-body">
                  <p>
                    Choose this for a finish that’s clean and modern, with a hint of sheen that
                    makes photos, graphics, and fonts sing.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img
                    src={paperTypeEggshell}
                    className="img img-responsive"
                    alt="Eggshell Paper"
                  />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Eggshell</div>
                <div className="section-body">
                  <p>
                    Prefer something traditional? Eggshell has a slight textured feel, with a matte
                    finish that makes colors look richer and more intense.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img
                    src={paperTypeRecycled}
                    className="img img-responsive"
                    alt="Recycled Paper"
                  />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Recycled</div>
                <div className="section-body">
                  <p>
                    Soft to the touch and 100% made of post-consumer waste, this paper has a smooth
                    surface with subtle but visible texture.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img
                    src={paperTypePearlescent}
                    className="img img-responsive"
                    alt="Pearlescent Paper"
                  />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Pearlescent</div>
                <div className="section-body">
                  <p>
                    Craving something chic? Pearlescent is an iridescent paper with a glossy, subtle
                    shimmer finish on both sides.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img src={paperTypeLinen} className="img img-responsive" alt="Linen Paper" />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Linen</div>
                <div className="section-body">
                  <p>
                    Elegant and versatile, this lightweight, flexible paper has a distinct
                    crosshatch texture that mimics the look of linen fabric.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img src={paperTypeNatural} className="img img-responsive" alt="Natural Paper" />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Natural</div>
                <div className="section-body">
                  <p>
                    This thick, sturdy paper has a highly-textured look and feel that’s ideal for
                    elegant watercolor and painterly designs.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img
                    src={paperTypeDoubleThick}
                    className="img img-responsive"
                    alt="Double Thick Paper"
                  />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Double Thick</div>
                <div className="section-body">
                  <p>
                    Extra durable, this paper is twice as thick as a credit card, with a slight bend
                    and smooth, creamy surface.
                  </p>
                </div>
              </div>
            </div>
            <div className="paper-type-section paper-type-section-row">
              <div className="paper-type-img-column hidden-xs">
                <figure className="img-wrapper">
                  <img
                    src={paperTypeTripleThick}
                    className="img img-responsive"
                    alt="Triple Thick Paper"
                  />
                </figure>
              </div>
              <div className="paper-type-content-column">
                <div className="section-header">Triple Thick</div>
                <div className="section-body">
                  <p>
                    This extra-thick paper looks and feels like a hard notebook cover that’s nearly
                    unbendable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaperTypeModal;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/PaperTypeModal/PaperTypeModal.jsx